import { CardContent, Tooltip, Typography } from '@mui/material';
import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import TitleCardText from '@src/main/ui/components/common/Dashboard/common/fields/title/TitleCardText';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { FC } from 'react';
import { IconId } from '../../../Icon/IconId';
import styles from './DashboardCardResumeHeader.module.scss';

interface DashboardCardResumeHeaderProps {
  title: string;
  icon: IconId;
  isCertified?: boolean;
  isShowAll?: boolean;
  highlighFields?: HighlighFields[];
}

const defaultProps = { isCertified: false, isShowAll: false, highlighFields: undefined };

const DashboardCardResumeHeader: FC<DashboardCardResumeHeaderProps> = ({
  title,
  icon,
  isCertified,
  isShowAll,
  highlighFields,
}) => (
  <CardContent
    sx={{
      paddingBottom: 1,
      paddingRight: 5,
    }}
  >
    <div className={styles.dashboardCardResumeHeader__content}>
      <span className={styles.dashboardCardResumeHeader__icon}>
        <Icon iconId={icon} />
      </span>
      <Typography variant="h6">
        <span className={styles.dashboardCardResumeHeader__title}>
          <TitleCardText title={title} highlighFields={highlighFields} />
        </span>
      </Typography>
      {!isShowAll && (
        <Tooltip title="Only users with permission can see this dashbaord">
          <span className={styles.dashboardCardResumeHeader__showAll}>
            <Icon iconId="lock" />
          </span>
        </Tooltip>
      )}
      {isCertified ? (
        <Tooltip title="Certified">
          <span className={styles.dashboardCardResumeHeader__certified}>
            <Icon iconId="certified" />
          </span>
        </Tooltip>
      ) : undefined}
    </div>
  </CardContent>
);

DashboardCardResumeHeader.defaultProps = defaultProps;

export default DashboardCardResumeHeader;
